import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

export type VisionSuggestion = {
  nom: string;
  categorie: string;
  sousCategorie: string;
  confidence: number;
  description: string;
};

export type VisionAnalyzeResponse = {
  suggestions: VisionSuggestion[];
  source: 'openrouter' | 'fallback';
  warning?: string;
};

export type VisionConfigResponse = {
  enabled: boolean;
  model: string;
  apiConfigured: boolean;
};

export const useVisionConfig = (enabled: boolean) =>
  useQuery<VisionConfigResponse>({
    queryKey: ['ai', 'vision', 'config'],
    queryFn: async () => {
      const { data } = await apiClient.get('/ai/vision/config');
      return data;
    },
    enabled,
    staleTime: 60_000,
  });

export const useAnalyzeVision = () =>
  useMutation({
    mutationFn: async (image: string) => {
      const { data } = await apiClient.post<VisionAnalyzeResponse>('/ai/vision/analyze', { image });
      return data;
    },
  });

export const useAnalyzeVisionBatch = () =>
  useMutation({
    mutationFn: async (payload: { images: string[]; contextLabel?: string }) => {
      const { data } = await apiClient.post<{ results: VisionSuggestion[][]; source: string }>(
        '/ai/vision/analyze-batch',
        payload,
      );
      return data;
    },
  });
